import {Badge} from "react-bootstrap";
import React from "react";

export default function ShopStatusTableCell({ id, className, children, rowData }) {
    // Der Status stammt aus dem B2C-Shop (WooCommerce). In der gemischten Ansicht
    // stehen B2B-Bestellungen daneben, für die es ihn nicht gibt — dort ein Strich
    // statt einer leeren Zelle, damit erkennbar ist, dass hier nichts fehlt.
    const istB2b = Number(rowData.connection_id) === 1;

    return (
        <td key={id} className={`border px-4 py-2${className ? " " + className : ""}`}>
            {rowData.is_order_withdrawn
                ? <Badge bg="danger">Widerrufen</Badge>
                : istB2b
                    ? <span className="text-muted">–</span>
                    : children}
        </td>
    );
}
